import { render, staticRenderFns } from "./simpleMessage.vue?vue&type=template&id=4fabd9e4&scoped=true&"
import script from "./simpleMessage.vue?vue&type=script&lang=js&"
export * from "./simpleMessage.vue?vue&type=script&lang=js&"
import style0 from "./simpleMessage.vue?vue&type=style&index=0&id=4fabd9e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fabd9e4",
  null
  
)

export default component.exports